import React, { createContext, useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { createMuiTheme, ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

const ThemeContext = createContext();
const THEME_STORAGE_KEY = "whaticket-dark-mode";

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    const savedPreference = localStorage.getItem(THEME_STORAGE_KEY);
    return savedPreference === null ? true : savedPreference === "true";
  });

  const toggleTheme = () => {
    setDarkMode(prevMode => {
      const nextMode = !prevMode;
      localStorage.setItem(THEME_STORAGE_KEY, String(nextMode));
      return nextMode;
    });
  };

  const theme = useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: darkMode ? "dark" : "light",
          primary: {
            main: darkMode ? "#82b1ff" : "#2576d2",
            contrastText: darkMode ? "#10213a" : "#ffffff",
          },
          secondary: {
            main: darkMode ? "#ff5c7c" : "#f50057",
            contrastText: "#ffffff",
          },
        },
      }),
    [darkMode]
  );

  const contextValue = useMemo(() => ({ darkMode, toggleTheme }), [darkMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useThemeContext = () => useContext(ThemeContext);
